/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const customize = {
    customizeProductItem: (componentRegistry) => {
        function updateBadges(element) {
            const productData = element.getParams().props.product;
            let productId = productData.id;

            if (productData?.split_product) {
                productId = productData.variant_id;
            }

            const productItem = document.querySelector(`[data-product-id="${productId}"]`);
            const productHandle = productData.handle;
            productItem.setAttribute('data-product-handle', productHandle);

            const topImgRowLeft = productItem.querySelector('.boost-sd__product-image-column--in-top.boost-sd__product-image-column--left');
            const topImgRowRight = productItem.querySelector('.boost-sd__product-image-column--in-top.boost-sd__product-image-column--right');
            const bottomImgRowRight = productItem.querySelector('.boost-sd__product-image-column--in-bottom.boost-sd__product-image-column--right');

            if (productItem && productData) {
                const saleLabelHtml = `
                    <span class="boost-sd-custom-sale-label">
                        SALE
                    </span>
                `;
                const outofstockLabelHtml = `
                    <span class="boost-sd-custom-sale-label">
                        Sold Out
                    </span>
                `;
                const badgeLabelsHtml = buildBadgeLabels(productData);
                const wishlistHtml = `
                    <button class="button-add-remove-wishlist button boost-pfs-wishlistbtn" type="button" onclick="onClickEgWishlistButton(this, event)" style="display: block;">
                <span data-add="" style="display: inline-flex;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="icon icon-wishlist bi bi-heart" viewBox="0 0 16 16">
                        <path d="M12.6,0.8v13.6L8.3,9.5L7.9,9L7.5,9.5l-4.1,4.9V0.8H12.6 M13.1,0.3H2.9v15.4l5-5.9l5.2,5.9V0.3L13.1,0.3z"></path>
                    </svg>
                    <span class="visually-hidden">
                        Add to wishlist
                    </span>
                </span>
                <span data-remove="" style="display: none;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="icon icon-wishlist bi bi-heart-fill" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M2.9 15.7V.3h10.2v15.4L7.9 9.8l-5 5.9z"></path>
                    </svg>
                    <span class="visually-hidden">
                        Remove from wishlist
                    </span>
                </span>
            </button>
                `;

                if (topImgRowRight) {
                    topImgRowRight.innerHTML = badgeLabelsHtml;
                }
                if (bottomImgRowRight) {
                    bottomImgRowRight.innerHTML = wishlistHtml;
                }
                // if (topImgRowLeft && productData?.percent_sale_min > 0) {
                //     topImgRowLeft.innerHTML = saleLabelHtml;
                // }
            }
        }

        // Build functions
        const buildBadgeLabels = (data) => {
            let badgeLabel = '';

            if (data.tags) {
                for (let i = 0; i < data.tags.length; i++) {
                    const tag = data.tags[i];
                    if (tag.indexOf('SEPT24_BOGOF') !== -1) {
                        const preBadgeLabel = '<img class="custom-tag-label" src="https://cdn.shopify.com/s/files/1/0016/0199/4822/files/SAS-bogoA.svg?v=1725444535">';
                        badgeLabel += preBadgeLabel;
                        break;
                    }
                }
            }

            return badgeLabel;
        }

        // Update grid view & list view
        const updateProductItemGridView = {
            name: 'Update badges for grid view #182836',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    updateBadges(element);
                }
            })
        };

        const updateProductItemListView = {
            name: 'Update badges for list view #182836',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    updateBadges(element);

                }
            })
        };

        // Update Default image
        const updateDefaultImage = {
            name: 'Update default image for product no image',
            enabled: true,
            apply: () => ({
                props(props, element) {
                    try {
                        console.log(props);
                        if (props?.images && props.images.length > 0) {
                            let image = props.images[0];
                            if (image.indexOf('boost-pfs-no-image.jpg') != -1) {
                                if (typeof boostSDCustom !== 'undefined' && boostSDCustom?.asset_url) {
                                    let newUrl = 'https:' + boostSDCustom.asset_url.split('boost-pfs.js')[0] + 'boost-pfs-no-image.jpg';
                                    props.images[0] = newUrl;
                                }
                            }
                        }
                        return props;
                    } catch(error) {
                        console.log(error);
                    }
                }
            })
        };

        // Register updateProductList When ProductList is rendered
        componentRegistry.useComponentPlugin('ProductItem', updateProductItemGridView);
        componentRegistry.useComponentPlugin('ProductItemListViewLayout', updateProductItemListView);
        componentRegistry.useComponentPlugin('ProductImage', updateDefaultImage);
    }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    customize.customizeProductItem
]);

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
   (componentRegistry) => {
      componentRegistry.useComponentPlugin('FormatCurrency', {
         name: 'Show Trailing Zeros',
         apply: () => ({
            afterRender: (element) => {
               try {
                  // Start customization--------------------------------------------
                  const formatMoneyHelper = element.getHelpers().formatMoney;
                  const value = element.getParams().props.value; // Get price
                  const customValue = formatMoneyHelper(Number(value), window.boostSDAppConfig?.shop?.money_format, true);

                  element.getRootElm().querySelector('.boost-sd__format-currency span').innerHTML = customValue;
                  // End-------------------------------------------------------------
               } catch (e) {
                  console.error(e);
               }
            },
         }),
      });
   }
]);